import LineChart from "components/charts/LineChart";
import React, { useState } from "react";
import { lineChartOptionsProjectStatus } from "config/charts";
import Card from "components/card";
import { ProfileStats } from 'utils/dashboardDataHelper';

function UserStatistics() {
  const [profileStats] = useState<ProfileStats>({
    totalProfiles: 5127,
    mentorCount: 1542,
    menteeCount: 3585,
    usersPerMonth: [3456, 3678, 3892, 4123, 4387, 4542, 4678, 4789, 4923, 5012, 5089, 5127],
    fieldCounts: {
      userObjectives: {},
      userGoals: {},
      userSources: {},
      userStreaks: {},
      prefAIChat: {},
      prefMentorshipChat: {},
    },
    topEntries: [],
  });

  const lineChartDataProjectStatus = [
    {
      name: "Total Profiles",
      data: profileStats.usersPerMonth,
    },
    {
      name: "Mentors",
      data: [1037, 1103, 1168, 1237, 1316, 1363, 1403, 1437, 1477, 1504, 1527, 1542],
    },
    {
      name: "Mentees",
      data: [2419, 2575, 2724, 2886, 3071, 3179, 3275, 3352, 3446, 3508, 3562, 3585],
    },
  ];

  return (
    <Card extra={"p-5 text-dm lg:h-full flex flex-col"}>
      <div className="relative flex items-center justify-between">
        <p className="text-lg font-bold text-navy-700 dark:text-white">
          User Statistics
        </p>
      </div>
      {/* Mentors, Mentees, and Total Users Section */}
      <div className="mt-4 grid grid-cols-3 gap-4 mb-4">
        <div className="flex items-center justify-between p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg">
          <div>
            <p className="text-sm font-medium text-gray-600">Mentors</p>
            <p className="text-xl font-bold text-navy-700 dark:text-white">
              {profileStats.mentorCount}
            </p>
          </div>
          <div className="text-yellow-500 text-xl">⭐</div>
        </div>
        <div className="flex items-center justify-between p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          <div>
            <p className="text-sm font-medium text-gray-600">Mentees</p>
            <p className="text-xl font-bold text-navy-700 dark:text-white">
              {profileStats.menteeCount}
            </p>
          </div>
          <div className="text-blue-500 text-xl">🎓</div>
        </div>
        <div className="flex items-center justify-between p-3 bg-purple-50 dark:bg-purple-900/20 rounded-lg">
          <div>
            <p className="text-sm font-medium text-gray-600">Total Users</p>
            <p className="text-xl font-bold text-navy-700 dark:text-white">
              {profileStats.mentorCount + profileStats.menteeCount}
            </p>
          </div>
          <div className="text-purple-500 text-xl">👥</div>
        </div>
      </div>

      {/* Charts */}
      <div className="flex-1 w-full overflow-hidden min-h-[180px]">
        {lineChartDataProjectStatus[0].data.length > 0 && (
        <LineChart
          chartData={lineChartDataProjectStatus}
          chartOptions={lineChartOptionsProjectStatus}
        />
      )}
      </div>
    </Card>
  );
}

export default UserStatistics;
